<template>
  <div>
    <v-dialog persistent v-model="dialog" width="50%">
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
          <slot />
        </span>
      </template>
      <v-form
        ref="form"
        v-model="form.valid"
        lazy-validation
        @submit.prevent="onSubmit"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            <span>Add/Edit User Request</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="form.fields.title"
              :rules="form.rules.title"
              label="User Request Title"
              required
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" color="primary" :disabled="!form.valid">
              {{ this.edit ? 'UPDATE' : 'CREATE' }}
            </v-btn>

            <v-spacer></v-spacer>
            <v-btn color="red" text @click="dialog = false">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import { requiredRule } from '@/utils/rules.js';
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('proxyApi');
export default {
  name: 'UserRequestForm',
  data() {
    return {
      edit: false,
      form: {
        valid: false,
        fields: {
          title: this.selectedRequest?.title
        },
        rules: {
          title: [requiredRule()]
        }
      },
      dialog: false
    };
  },
  watch: {
    dialog(visible) {
      if (visible) {
        this.form.fields.title = this.selectedRequest?.title;
        this.edit =
          this.form.fields.title.toString() === this.selectedRequest?.title;
      }
    },
    'form.fields.title'(newValue) {
      this.edit = newValue === this.selectedRequest?.title;
    }
  },
  methods: {
    ...mapActions(['postUserRequest']),
    async onSubmit() {
      let title = this.form.fields.title.toString();
      if (title === '') return;
      let request = JSON.parse(this.editorRequest);
      let userRequest = {
        ...this.selectedRequest,
        ...{ title },
        ...{ request }
      };
      if (!this.edit) {
        userRequest._id = null;
      }
      await this.postUserRequest(userRequest);
      this.dialog = false;
    }
  },
  props: {
    editorRequest: String,
    selectedRequest: {
      type: Object,
      require: true
    }
  }
};
</script>
